// ZH UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': '公寓和酒店',
  'site.currency': '货币',
  'site.language': '语言',
  'site.currencySelector': '选择货币',
  'site.languageSelector': '选择语言',
  'site.menu': '菜单',
  'site.signIn': '登录',
  'site.signOut': '退出',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': '打开菜单',
  'site.footer.copyright': '版权所有。',
  'site.footer.manageBooking': '管理您的预订',
  'site.footer.terms': '条款与条件',
  'site.footer.privacy': '隐私政策',
  'site.trust.bestPrice': '最优惠价格保证',
  'site.trust.bestPriceDesc': '享受最优价格。',
  'site.trust.flexibleBooking': '灵活预订',
  'site.trust.flexibleBookingDesc': '轻松更改和取消。',
  'site.trust.securePayments': '安全支付',
  'site.trust.securePaymentsDesc': '值得信赖的安全结账。',
  'site.trust.localSupport': '本地支持',
  'site.trust.localSupportDesc': '我们随时为您提供帮助。',
  'home.heroTitle': '找到理想住宿',
  'home.inAustralia': '在澳大利亚',
  'home.heroSubtitle': '满足各种出行需求的公寓和酒店',
  'home.errorLoading': '无法加载住宿信息。',
  'home.noPropertiesTitle': '当前没有可预订的住宿。',
  'home.noPropertiesDescription': '尝试搜索目的地以探索可用住宿。',
  'home.exploreStays': '探索住宿',
  'home.property': '套房源',
  'home.property_one': '套房源',
  'home.property_other': '套房源',
  'home.properties': '套房源',
  'home.foundInAustralia': '在澳大利亚找到',
  'search.errorLoading': '无法加载可用房态，请重试。',
  'search.noResults': '没有符合您搜索条件的住宿。',
  'search.mapFollow': '移动地图时同步搜索',
  'search.chooseLocationTitle': '选择地点',
  'search.chooseLocationDescription': '请先选择目的地，再搜索可用住宿。',
  'search.chooseDatesTitle': '选择日期',
  'search.pastCheckIn': '入住日期不能为过去。',
  'search.checkOutAfterCheckIn': '退房日期必须在入住日期之后。',
  'search.property': '套房源',
  'search.property_one': '套房源',
  'search.property_other': '套房源',
  'search.properties': '套房源',
  'search.found': '找到',
  'widget.where': '目的地',
  'widget.location': '位置',
  'widget.checkInOut': '入住 / 退房',
  'widget.guests': '宾客',
  'widget.rooms': '客房',
  'widget.promoCode': '优惠码',
  'widget.promoPlaceholderCompact': '添加优惠码（可选）',
  'widget.promoPlaceholder': '可选',
  'widget.search': '搜索',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': '成人',
  'widget.adults': '成人',
  'widget.child': '儿童',
  'widget.children': '儿童',
  'widget.decreaseAdults': '减少成人',
  'widget.increaseAdults': '增加成人',
  'widget.decreaseChildren': '减少儿童',
  'widget.increaseChildren': '增加儿童',
  'widget.room': '客房',
  'widget.adultOption': '{count} 位成人',
  'widget.adultOption_one': '{count} 位成人',
  'widget.adultOption_other': '{count} 位成人',
  'widget.childOption': '{count} 名儿童',
  'widget.childOption_one': '{count} 名儿童',
  'widget.childOption_other': '{count} 名儿童',
  'widget.roomOption': '{count} 间客房',
  'widget.roomOption_one': '{count} 间客房',
  'widget.roomOption_other': '{count} 间客房',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': '无法加载位置，请重试。',
  'widget.searchAria': '搜索可用房态',
  'widget.dateErrorRequired': '请选择入住和退房日期。',
  'widget.dateErrorPast': '入住日期不能为过去。',
  'widget.dateErrorRange': '退房日期必须在入住日期之后。',
  'widget.dateRange.placeholder': '选择入住和退房日期',
  'widget.dateRange.selectCheckout': '选择退房日期',
  'widget.dateRange.aria.checkIn': '入住',
  'widget.dateRange.aria.checkOut': '退房',
  'widget.dateRange.aria.picker': '入住 / 退房日期范围选择器',
  'widget.dateRange.previousMonth': '上个月',
  'widget.dateRange.nextMonth': '下个月',
  'widget.dateRange.selectCheckIn': '选择入住日期',
  'widget.dateRange.selectCheckOut': '选择退房日期',
  'widget.dateRange.resetToday': '重置为今天',
  'widget.dateRange.done': '完成',
  'property.heroAlt': '住宿主图',
  'property.fallbackName': '{site} 精选住宿',
  'property.chooseRoom': '选择您的客房',
  'property.filterBy': '筛选：',
  'property.filterAll': '全部房型',
  'property.filterStudios': '单间公寓',
  'property.filter1Bed': '1 卧室',
  'property.filter2Bed': '2 卧室',
  'property.filterApartments': '公寓',
  'property.sortBy': '排序：',
  'property.sortRecommended': '推荐',
  'property.sortPriceLow': '价格：从低到高',
  'property.sortPriceHigh': '价格：从高到低',
  'property.errorLoading': '无法加载可用房态，请重试。',
  'property.noRooms': '没有可用客房',
  'property.noRoomsDescription': '尝试更换日期或入住人数。',
  'property.totalForNights': '{nights} 晚总计',
  'property.perNight': '每晚',
  'property.night': '晚',
  'property.night_one': '晚',
  'property.night_other': '晚',
  'property.nights': '晚',
  'property.freeCancellation': '免费取消',
  'property.selectRoom': '选择客房',
  'property.selected': '已选择',
  'property.continue': '继续',
  'property.previousPhoto': '上一张照片',
  'property.nextPhoto': '下一张照片',
  'property.addToWishlist': '加入心愿单',
  'property.popularChoice': '热门选择',
  'property.showMore': '显示更多',
  'property.showLess': '显示更少',
  'property.maxOccupancy': '最多入住：',
  'property.size': '面积：',
  'property.bedType': '床型：',
  'property.roomAmenities': '客房设施',
  'property.showMoreAmenities': '还有 {count} 项',
  'property.guests': '宾客',
  'property.adults': '成人',
  'property.children': '儿童',
  'property.onlyRoomsLeft': '仅剩 {count} 间客房',
  'property.onlyRoomsLeft_one': '仅剩 {count} 间客房',
  'property.onlyRoomsLeft_other': '仅剩 {count} 间客房',
  'property.lastBookedMinutes': '最近一次预订在 {count} 分钟前',
  'property.lastBookedMinutes_one': '最近一次预订在 {count} 分钟前',
  'property.lastBookedMinutes_other': '最近一次预订在 {count} 分钟前',
  'property.lastBookedHours': '最近一次预订在 {count} 小时前',
  'property.lastBookedHours_one': '最近一次预订在 {count} 小时前',
  'property.lastBookedHours_other': '最近一次预订在 {count} 小时前',
  'property.lastBookedDays': '最近一次预订在 {count} 天前',
  'property.lastBookedDays_one': '最近一次预订在 {count} 天前',
  'property.lastBookedDays_other': '最近一次预订在 {count} 天前',
  'property.checkInTime': '入住 {time}',
  'property.checkOutTime': '退房 {time}',
  'property.compare': '对比',
  'property.taxesIncluded': '每晚含税费',
  'property.chooseRate': '选择您的价格方案',
  'property.yourSelection': '您的选择',
  'property.aboutRoom': '关于此客房',
  'property.roomDetails': '客房详情',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': '返回客房列表',
  'property.standardRate': '标准价格',
  'property.noPromotion': '此价格方案没有可用优惠。',
  'property.youSave': '节省 {percent}% — {amount}',
  'property.inclusions': '包含：',
  'property.viewAllPhotos': '查看所有照片',
  'property.seeOnMap': '在地图中查看',
  'room.perNight': '晚',
  'room.sleeps': '可住',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': '可预订',
  'room.select': '选择',
  'room.selected': '已选择',
  'card.viewAvailability': '查看可用房态',
  'card.from': '起',
  'card.night': '晚',
  'card.checkAvailability': '查看可用房态',
  'card.saveToFavourites': '收藏',
  'card.ratingExcellent': '优秀',
  'card.ratingVeryGood': '很好',
  'card.ratingGood': '良好',
  'card.ratingGuest': '住客评分',
  'guest.stepChooseRoom': '选择客房',
  'guest.stepGuestDetails': '宾客信息',
  'guest.stepPayment': '支付',
  'guest.stepConfirmation': '确认',
  'guest.title': '填写宾客信息',
  'guest.subtitle': '请提供您的信息。',
  'guest.firstName': '名字',
  'guest.lastName': '姓氏',
  'guest.email': '电子邮箱',
  'guest.emailHint': '预订确认邮件将发送至该邮箱。',
  'guest.country': '国家/地区',
  'guest.selectCountry': '选择国家/地区',
  'guest.searchCountry': '搜索国家/地区…',
  'guest.loadingCountries': '正在加载国家/地区…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': '邮政编码',
  'guest.phone': '电话号码',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': '请输入电话号码',
  'guest.address': '地址',
  'guest.city': '城市',
  'guest.specialRequests': '特殊要求（可选）',
  'guest.specialRequestsPlaceholder': '有什么特殊要求？',
  'guest.termsPrefix': '完成此预订即表示我同意',
  'guest.terms': '条款与条件',
  'guest.termsAnd': '和',
  'guest.privacy': '隐私政策',
  'guest.termsSuffix': '，并接受预订条件。',
  'guest.marketingOptOut': '我不想收到营销信息。',
  'guest.cardVerify': '将对您的银行卡进行临时 1 {currency} 的预授权验证。现在不会扣款。',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': '将在住宿现场收取款项。',
  'guest.noRoomsSelected': '尚未选择客房。',
  'guest.noPropertySelected': '尚未选择住宿。',
  'guest.paymentStillLoading': '支付选项仍在加载中，请稍后再试。',
  'guest.submitProcessing': '处理中…',
  'guest.submitVerifyCard': '验证银行卡并确认预订',
  'guest.submitConfirm': '确认预订',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': '支付',
  'payment.method': '支付方式',
  'payment.cardDetailsHint':
    '请在下方安全输入银行卡信息。您的卡信息将被令牌化，不会进入我们的服务器。',
  'payment.loadingForm': '正在加载支付表单…',
  'payment.formUnavailable': '支付表单不可用。',
  'payment.acceptTerms': '我接受条款与条件及取消政策。',
  'payment.payNow': '立即支付',
  'payment.processing': '处理中…',
  'payment.noRoomsSelected': '尚未选择客房。',
  'payment.redirecting': '正在跳转至安全支付页面…',
  'payment.notConfigured': '该住宿尚未配置 Quickstream。',
  'payment.noScript': 'Quickstream 支付服务未能加载，请刷新页面。',
  'payment.formNotLoaded': '支付表单未能加载，请刷新页面。',
  'payment.cardDetails': '支付失败，请检查银行卡信息。',
  'payment.tokenizationFailed': '银行卡令牌化失败，请重试。',
  'payment.failed': '支付失败。',
  'payment.statusResult': '支付状态：{status}。请重试。',
  'confirmation.loading': '正在加载您的预订…',
  'confirmation.notFound': '找不到预订，请核对预订编号后重试。',
  'confirmation.errorGeneric': '无法确认您的预订，请联系客服。',
  'confirmation.errorLoadDetails': '无法加载预订详情。',
  'confirmation.couldNotComplete': '我们无法完成您的支付',
  'confirmation.startNew': '开始新的预订',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': '找不到支付会话，请联系客服。',
  'confirmation.paymentStateInvalid': '支付状态无效，请重新开始。',
  'confirmation.paymentFailedDeclined':
    '您的支付无法完成，请检查银行卡信息后重试，或使用其他支付方式。',
  'confirmation.paymentTimeout': '支付超时，请重试。',
  'confirmation.paymentGatewayUnavailable': '支付系统暂时不可用，请稍后重试。',
  'confirmation.paymentUnknown': '无法确认支付：{message}。',
  'confirmation.paymentGenericError': '无法确认支付，请重试或联系客服。',
  'summary.title': '您的预订摘要',
  'summary.yourBooking': '您的预订摘要',
  'summary.noRoomsSelected': '尚未选择客房。',
  'summary.checkIn': '入住',
  'summary.checkOut': '退房',
  'summary.lengthOfStay': '入住时长',
  'summary.guests': '宾客',
  'summary.nights': '{nights} 晚',
  'summary.nights_one': '{nights} 晚',
  'summary.nights_other': '{nights} 晚',
  'summary.totalForNights': '{nights} 晚总计',
  'summary.includingTaxes': '含税费',
  'summary.discount': '节省 {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': '预订已确认！',
  'detail.received': '预订已收到',
  'detail.referenceIntro': '您的预订编号是',
  'detail.reservationId': '预订编号：',
  'detail.processing': '您的预订正在处理中。支付确认后，您将收到确认邮件。',
  'detail.guest': '宾客',
  'detail.rooms': '客房',
  'detail.night': '晚',
  'detail.nights': '晚',
  'detail.adult': '成人',
  'detail.adults': '成人',
  'detail.child': '儿童',
  'detail.infant': '婴儿',
  'detail.priceBreakdown': '价格明细',
  'detail.subtotal': '小计',
  'detail.taxes': '税费',
  'detail.fees': '服务费',
  'detail.discounts': '折扣',
  'detail.surcharge': '银行卡附加费',
  'detail.grandTotal': '总计',
  'priceBreakdown.roomSubtotal': '客房小计',
  'priceBreakdown.total': '合计',
  'detail.deposit': '押金',
  'detail.depositDueBy': '截止日期',
  'detail.arrival': '到店',
  'detail.specialRequests': '特殊要求',
  'detail.backToHome': '返回首页',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': '重试',
  'shared.close': '关闭',
  'shared.back': '返回',
  'shared.previous': '上一个',
  'shared.next': '下一个',
  'validation.firstNameRequired': '请填写名字',
  'validation.lastNameRequired': '请填写姓氏',
  'validation.emailRequired': '请填写有效电子邮箱',
  'validation.phoneRequired': '请填写电话号码',
  'validation.addressRequired': '请填写地址',
  'validation.cityRequired': '请填写城市',
  'validation.countryRequired': '请选择国家/地区',
  'validation.postalCodeRequired': '请填写邮政编码',
  'error.pmsUnavailable': '抱歉，该客房在您选择的日期不再可用。请返回并选择其他日期或客房。',
  'error.pmsSyncError': '我们无法连接住宿系统，请稍后重试。',
  'error.paymentNotConfigured': '该住宿尚未配置支付。请选择其他住宿或联系客服。',
  'error.paymentStartFailed': '启动支付时出现问题，请重试。',
  'error.bookingFailed': '预订失败，请重试。',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': '预订您的住宿',
  'site.title.suffix': '公寓和酒店',
  'site.title.home': '首页',
  'site.title.search': '搜索',
  'site.title.property': '住宿',
  'site.title.room': '客房',
  'site.title.guestDetails': '宾客信息',
  'site.title.payment': '支付',
  'site.title.confirmation': '预订已确认',
  'site.title.bookingLookup': '查找您的预订',
  'site.title.bookingDetails': '预订详情',
  'site.title.cancellation': '取消预订',
  'site.title.reservationDetail': '预订详情',
  'site.title.signIn': '登录',
  'site.title.signUp': '注册',
  'site.title.notFound': '页面未找到',
  'notFound.title': '页面未找到',
  'notFound.message': '您要查找的页面不存在。',
  'notFound.backHome': '返回首页',
  'home.heroAlt': '澳大利亚城市天际线',
  'home.featuredProperties': '精选住宿',
  'home.popularDestinations': '热门目的地',
  'common.reviews': '{count} 条评价',
  'common.reviews_one': '{count} 条评价',
  'common.reviews_other': '{count} 条评价',
  'common.loading': '加载中',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': '/',
  'common.select': '选择…',
  'common.search': '搜索…',
  'common.selectLocation': '选择地点',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': '无可用选项',
  'common.code': '代码',
  'common.searchCode': '搜索代码…',
  'filter.title': '筛选',
  'filter.price': '价格',
  'filter.priceMinimum': '最低',
  'filter.priceMaximum': '最高',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': '住宿类型',
  'filter.propertyType.hotel': '酒店',
  'filter.propertyType.apartment': '公寓',
  'filter.propertyType.resort': '度假村',
  'filter.amenities': '设施',
  'filter.amenity.pool': '泳池',
  'filter.amenity.parking': '停车',
  'filter.amenity.breakfast': '含早餐',
  'filter.rating': '评分',
  'filter.rating.any': '任意评分',
  'filter.rating.5': '5 星',
  'filter.rating.4': '4 星及以上',
  'filter.rating.3': '3 星及以上',
  'filter.more': '更多',
  'filter.more.freeCancellation': '免费取消',
  'filter.more.payAtProperty': '到店付款',
  'filter.clear': '清除',
  'filter.apply': '应用筛选',
  'card.reviews_one': '条评价',
  'card.reviews_other': '条评价',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': '年龄 0 - 12 岁',
  'auth.orContinueWith': '或通过以下方式继续',
  'auth.signIn.title': '登录您的账户',
  'auth.signIn.subtitle': '欢迎回来！登录以管理您的预订、查看住宿并获取专属优惠。',
  'auth.email': '电子邮箱',
  'auth.emailPlaceholder': '请输入电子邮箱',
  'auth.emailRequired': '请填写电子邮箱。',
  'auth.emailInvalid': '请输入有效的电子邮箱地址。',
  'auth.password': '密码',
  'auth.passwordPlaceholder': '请输入密码',
  'auth.createPasswordPlaceholder': '创建密码',
  'auth.passwordRequired': '请填写密码。',
  'auth.passwordMinLength': '密码长度至少为 {min} 个字符。',
  'auth.passwordPattern': '密码必须包含字母和数字。',
  'auth.passwordHint': '请使用至少 {min} 个字符，混合使用字母、数字和符号。',
  'auth.showPassword': '显示密码',
  'auth.hidePassword': '隐藏密码',
  'auth.keepSignedIn': '保持登录状态',
  'auth.forgotPassword': '忘记密码？',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': '登录',
  'auth.signingIn': '正在登录…',
  'auth.signInError': '登录失败，请重试。',
  'auth.googleError': 'Google 登录失败。',
  'auth.noAccount': '还没有账户？',
  'auth.createAccount': '创建账户',
  'auth.signUp.title': '创建您的账户',
  'auth.signUp.subtitle': '加入 {site}，管理您的预订、收藏心仪的住宿并获取专属优惠。',
  'auth.firstName': '名字',
  'auth.firstNamePlaceholder': '请输入名字',
  'auth.firstNameRequired': '请填写名字。',
  'auth.lastName': '姓氏',
  'auth.lastNamePlaceholder': '请输入姓氏',
  'auth.lastNameRequired': '请填写姓氏。',
  'auth.mobile': '手机号码',
  'auth.mobilePlaceholder': '请输入手机号码',
  'auth.dialingCode': '国家区号',
  'auth.mobileRequired': '请填写手机号码。',
  'auth.mobileInvalid': '请输入有效的手机号码。',
  'auth.confirmPassword': '确认密码',
  'auth.confirmPasswordPlaceholder': '请确认密码',
  'auth.termsAgree': '我同意',
  'auth.termsRequired': '您必须同意条款与条件和隐私政策。',
  'auth.marketingConsent': '我希望接收来自 {site} 的专属优惠和旅行灵感。',
  'auth.signUpError': '无法创建账户，请重试。',
  'auth.signUp': '注册',
  'auth.creatingAccount': '正在创建账户…',
  'auth.createAccountButton': '创建账户',
  'auth.alreadyHaveAccount': '已有账户？',
  'auth.passwordMismatch': '两次输入的密码不一致。',
  'pricing.title': '价格摘要',
  'pricing.noRoomsSelected': '尚未选择客房，请返回并选择客房。',
  'pricing.backToAvailability': '返回可用房态',
  'pricing.continue': '继续填写宾客信息',
  'property.youSavePercent': '节省 {percent}%',
  'property.includingTaxesFees': '（含税费）',
  'map.zoomIn': '放大',
  'map.zoomOut': '缩小',
  'map.viewFullMap': '查看完整地图',
  'booking.progress': '预订进度',
  'reservationDetail.resetAria': '重置预订状态',
  'bookingLookup.title': '查找您的预订',
  'bookingLookup.description': '输入预订编号和电子邮箱，以查看、修改或取消您的预订。',
  'bookingLookup.bookingReference': '预订编号',
  'bookingLookup.placeholder': '例如 SYD-260815-0001',
  'bookingLookup.lookingUp': '正在查找…',
  'bookingLookup.findBooking': '查找预订',
  'bookingLookup.notFound': '找不到预订。请尝试 BK-2026-001、alex.morgan@example.com 和 Morgan。',
  'cancellation.title': '取消预订',
  'cancellation.property': '住宿',
  'cancellation.details': '取消详情',
  'cancellation.penalty': '取消费用',
  'cancellation.refund': '退款金额',
  'cancellation.totalPaid': '已支付总额：',
  'cancellation.reasonLabel': '取消原因（可选）',
  'cancellation.understand': '我了解此操作无法撤销。',
  'cancellation.cancelledDemo': '您的预订已在此演示界面中取消。退款金额：{{refundAmount}}。',
  'cancellation.confirm': '确认取消',
  'cancellation.notFound': '找不到预订。',
  'bookingDetails.title': '预订详情',
  'bookingDetails.notFound': '找不到预订。',
  'bookingDetails.checkIn': '入住：',
  'bookingDetails.checkOut': '退房：',
  'bookingDetails.rooms': '客房',
  'bookingDetails.guest': '宾客',
  'bookingDetails.freeCancellationUntil': '{date} 前可免费取消',
  'bookingDetails.total': '总计：',
  'reservationDetail.loading': '正在加载您的预订…',
  'reservationDetail.noReference': '未提供预订编号。',
  'reservationDetail.loadError': '无法加载预订详情。',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': '正在加载地点…',
  'common.couldNotLoadLocations': '无法加载地点',
  'common.searchLocationPlaceholder': '搜索国家、城市或住宿',
  'common.collapse': '收起',
  'common.expand': '展开',
  'map.loadingGoogle': '正在加载 Google 地图…',
  'map.errorGoogle': '加载 Google 地图失败',
  'map.errorMap': '加载地图失败。',
  'map.greatLocation': '位置优越',
  'home.trust.secureBooking': '安全预订',
  'home.trust.secureBookingDesc': '您的信息安全无忧。',
  'home.trust.bestPrice': '最优惠价格保证',
  'home.trust.bestPriceDesc': '发现更低价格？我们将为您匹配。',
  'home.trust.localSupport': '24/7 支持',
  'home.trust.localSupportDesc': '我们随时为您提供帮助。',
  'home.trust.flexibleBooking': '灵活选择',
  'home.trust.flexibleBookingDesc': '精选房价可免费取消。',
  'promotion.memberPromo': '会员优惠',
  'promotion.save': '节省',
  'property.memberRate': '会员价',
  'property.hideAmenities': '隐藏设施',
  'property.showAllAmenities': '显示全部设施',
  'property.chooseRatePromo': '选择您偏好的价格方案 - 会员价享专属优惠！',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% 优惠',
  'gallery.imageAlt': '{title} 第 {current} / {total} 张',
  'gallery.thumbnailAlt': '查看第 {current} / {total} 张',
  'gallery.previewAlt': '{title} 预览',
  'detail.night_one': '晚',
  'detail.night_other': '晚',
  'detail.adult_one': '成人',
  'detail.adult_other': '成人',
  'detail.child_one': '儿童',
  'detail.child_other': '儿童',
  'detail.infant_one': '婴儿',
  'detail.infant_other': '婴儿',
} as const;
